// extracted by mini-css-extract-plugin
export default {"wrapper":"JTyy5qQpPE4iuFCif9kabA==","error":"DaAUxuvnF7YimA9+oXd6Cg==","tooltip":"_6J1Gpiy2ywM4zxM7WtM+kw=="};